module.exports = __webpack_public_path__ + "img/신사역 미용실.db363ec2.png";